import {EventEmitter} from 'eventemitter3'

export const pathwayEvent = new EventEmitter()

export const pathwayEventTypes = {
    TABLE_CHANGE: 'TABLE_CHANGE',
    DETAIL_CHANGE: 'DETAIL_CHANGE',
    DELETE: 'DELETE',
}

export function getPathwayEventKey(eventType) {
    if (!eventType) {
        return ''
    }

    switch (eventType) {
        case pathwayEventTypes.DELETE:
            return `PATHWAY_DELETE`

        case pathwayEventTypes.TABLE_CHANGE:
            return `PATHWAY_TABLE_CHANGE`

        case pathwayEventTypes.DETAIL_CHANGE:
            return `PATHWAY_DETAIL_CHANGE`

        default:
            return ''
    }
}

//#region TABLE CHANGE
export function onPathwayTableChangeListener(
    eventType = pathwayEventTypes.TABLE_CHANGE,
    data,
) {
    pathwayEvent.emit(getPathwayEventKey(eventType), data)
}

export function onPathwayTableChangeRemoveListener(
    eventType = pathwayEventTypes.TABLE_CHANGE,
) {
    pathwayEvent.removeListener(getPathwayEventKey(eventType))
}
//#endregion

//#region DETAIL CHANGE
export function onPathwayDetailChangeListener(
    eventType = pathwayEventTypes.DETAIL_CHANGE,
    data,
) {
    pathwayEvent.emit(getPathwayEventKey(eventType), data)
}

export function onPathwayDetailChangeRemoveListener(
    eventType = pathwayEventTypes.DETAIL_CHANGE,
) {
    pathwayEvent.removeListener(getPathwayEventKey(eventType))
}
//#endregion

//#region DETELE
// export function onPathwayDeleteListener(
//     eventType = pathwayEventTypes.DELETE,
//     data,
// ) {
//     pathwayEvent.emit(getPathwayEventKey(eventType), data)
// }

// export function onPathwayDeleteRemoveListener(
//     eventType = pathwayEventTypes.DELETE,
// ) {
//     pathwayEvent.removeListener(getPathwayEventKey(eventType))
// }
//#endregion
